var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5761",
    d: "M10 5.834a.833.833 0 0 0-.834.833V10a.833.833 0 0 0 1.667 0V6.667A.833.833 0 0 0 10 5.834Zm0 6.666a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667Zm8.091-6.2L13.7 1.91a.875.875 0 0 0-.592-.242H6.891a.875.875 0 0 0-.591.242L1.908 6.3a.875.875 0 0 0-.241.592v6.217c.003.22.089.432.241.591L6.3 18.092c.16.152.37.239.591.242h6.217a.875.875 0 0 0 .592-.242l4.392-4.392a.875.875 0 0 0 .241-.591V6.892a.875.875 0 0 0-.241-.592Zm-1.425 6.459-3.908 3.908H7.242l-3.909-3.908V7.242l3.909-3.908h5.516l3.909 3.908v5.517Z"
  })));
};
export default SvgError;